import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useState, FC } from "react";
import { SilentRequest } from "@azure/msal-browser";
import TotalsTable from "./TotalsTable";
import NewLostCustomersTable from "./NewLostCustomersTable";
import LicenseDeltasTables from "./LicenseDeltasTables";
import ItemizedAuditsTable from "./ItemizedAuditsTable";
import AuditForm from "./AuditForm";
import MonthlyLicenseAudit from "../../data/interfaces/monthlyLicenseAudit";
import { AuditRequest } from "../../data/interfaces/auditRequest";
import { getAudit } from "../../data/auditService";
import CustomContainer from "../../common/CustomContainer";
import PageTitle from "../../common/PageTitle";

type FormData = {
  startDate: Date;
  endDate: Date;
};

const AuditPage: FC = () => {
  const title = "License Audit";
  const [audit, setAudit] = useState<MonthlyLicenseAudit | null>(null);
  const { instance } = useMsal();

  const isAuthenticated = useIsAuthenticated();

  const submit = async (data: FormData) => {
    const account = instance.getAllAccounts()[0];

    const silentRequest: SilentRequest = {
      scopes: ["api://a22e7296-106f-4a00-af8d-f86edb386a1b/api_access"],
      account: account,
    };

    const token = await instance.acquireTokenSilent(silentRequest);

    const startDate = new Date(data.startDate)
    const endDate = new Date(data.endDate)
    startDate.setUTCHours(0,0,0,0)
    endDate.setUTCHours(23,59,59,999)

    const request: AuditRequest = {
      startDate: startDate,
      endDate: endDate,
    };

    const audit = await getAudit(request, token.accessToken);

    setAudit(audit);
  };

  return (
    <CustomContainer>
      {isAuthenticated === false ? (
        <div className="p-3 m-2">
          <h2>You must login to use this application.</h2>
        </div>
      ) : (
        <>
          <PageTitle title={title} />
          <AuditForm submitForm={submit} />
          {audit !== null ? (
            <div className="p-1">
              <TotalsTable licenseTotals={audit?.totals} />
              <NewLostCustomersTable customerChanges={audit?.customerChanges} />
              <LicenseDeltasTables counts={audit?.counts} />
              <ItemizedAuditsTable changeAudits={audit?.licenseChanges} />
            </div>
          ) : (
            <></>
          )}
        </>
      )}
    </CustomContainer>
  );
};

export default AuditPage;
